import { Col, Row, Table } from 'antd';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';

export default function WorkerBlacklist({ id }) {
  const { urldashboard, authentication } = useContext(DashboardContext);
  // table data

  const [addressData, setAddressData] = useState([]);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [totalRecordAddress, setTotalRecordAddress] = useState(0);
  const [paginationAddress, setPaginationAddress] = useState({
    page: 1,
    pageSize: 10,
  });

  const [companyData, setCompanyData] = useState([]);
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [totalRecordCompany, setTotalRecordCompany] = useState(0);
  const [paginationCompany, setPaginationCompany] = useState({
    page: 1,
    pageSize: 10,
  });

  useEffect(() => {
    getAddressList({
      page: paginationAddress?.page,
      pageSize: paginationAddress?.pageSize,
    });
    getCompanyList({
      page: paginationCompany?.page,
      pageSize: paginationCompany?.pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAddressList = async ({ page, pageSize }) => {
    setLoadingAddress(true);
    try {
      let url = `/worker/getBlacklisted/${
        id || sessionStorage.getItem('workerId')
      }`;
      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
        params: {
          page,
          pageSize,
        },
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setAddressData(items);
      setTotalRecordAddress(data?.totalRecord);
      setPaginationAddress({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoadingAddress(false);
    } catch (error) {
      setLoadingAddress(false);
      setAddressData([]);
    }
  };

  const getCompanyList = async ({ page, pageSize }) => {
    setLoadingCompany(true);
    try {
      let url = `/worker/getCompanyBlacklisted/${
        id || sessionStorage.getItem('workerId')
      }`;
      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
        params: {
          page,
          pageSize,
        },
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setCompanyData(items);
      setTotalRecordCompany(data?.totalRecord);
      setPaginationCompany({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoadingCompany(false);
    } catch (error) {
      setLoadingCompany(false);
      setCompanyData([]);
    }
  };

  const handlePaginationAddress = (newPage, newPageSize) => {
    getAddressList({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const handlePaginationCompany = (newPage, newPageSize) => {
    getCompanyList({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const addressColumns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>
          {index +
            1 +
            (paginationAddress?.page - 1) * paginationAddress?.pageSize}
        </>
      ),
    },
    {
      title: 'نوع بیزینس',
      dataIndex: 'businessTypeTitle',
      key: 'businessTypeTitle',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نام و آدرس مشتری/شرکت',
      dataIndex: 'companyAddress',
      key: 'companyAddress',
      align: 'center',
      render: (value, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>
            {record?.businessTypeTitle === 'کارلاین'
              ? record?.companyName
              : record?.customerName
              ? record?.customerName
              : '-'}
          </span>
          <span>{value ?? '-'}</span>
        </div>
      ),
    },
  ];

  const companyColumns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>
          {index +
            1 +
            (paginationCompany?.page - 1) * paginationCompany?.pageSize}
        </>
      ),
    },
    {
      title: 'نام شرکت',
      dataIndex: 'companyName',
      key: 'companyName',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
  ];

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Table
            title={() => 'براساس آدرس'}
            size='small'
            rowClassName={() => 'center'}
            columns={addressColumns}
            bordered={true}
            dataSource={addressData}
            loading={loadingAddress}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loadingAddress && (
            <CustomPagination
              totalRecord={totalRecordAddress}
              pagination={paginationAddress}
              handlePagination={handlePaginationAddress}
            />
          )}
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Table
            title={() => 'براساس مشتری/شرکت'}
            size='small'
            rowClassName={() => 'center'}
            columns={companyColumns}
            bordered={true}
            dataSource={companyData}
            loading={loadingCompany}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loadingCompany && (
            <CustomPagination
              totalRecord={totalRecordCompany}
              pagination={paginationCompany}
              handlePagination={handlePaginationCompany}
            />
          )}
        </Col>
      </Row>
    </>
  );
}
